import { BufferGeometry } from 'three';
export function validateGeometry(g: BufferGeometry) {
    const p = g.getAttribute('position'), idx = g.getIndex();
    if (!p || p.count < 1000 || !idx)
        throw Error('Неполная геометрия головы');
    for (let i = 0; i < p.array.length; i++)
        if (!Number.isFinite(p.array[i]))
            throw Error('Некорректная координата');
    for (let i = 0; i < idx.count; i++)
        if (idx.getX(i) >= p.count)
            throw Error('Индекс за пределами геометрии');
    g.computeBoundingBox();
    const b = g.boundingBox!;
    if (b.max.z - b.min.z < .5 || b.max.x - b.min.x < .5)
        throw Error('Модель не объёмная');
    const targets = g.morphAttributes.position ?? [];
    if (targets.length !== 13)
        throw Error('Отсутствует facial rig');
    for (const a of targets)
        if (a.count !== p.count)
            throw Error('Топология morph target отличается');
    return { vertices: p.count, triangles: idx.count / 3, morphs: targets.length, bounds: b };
}
